import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import './index.scss';

const PrivacyPolicy = () => {
    return (
        <React.Fragment>
          <div className={'content'}>
          <p>This Privacy Policy explains how ShipsLand corporate collects, uses and
                discloses information about you.
            </p>
            < br/>
            <p>
                We may change this Privacy Policy from time to time. If we make changes, we will
                notify you by revising the date at the top of this policy and in some cases, we
                may provide you with additional notice (such as adding a statement to our
                website or providing you with notification). We encourage you to review this
                Privacy Policy regularly to stay informed about our information practices and
                the choices available to you.
            </p>
            <br/>
            <p>
                <b>CONTENTS</b>
            </p>
            <br/>
            <p>
                <ul>
                    <li><Link className={'link'} to='/legal/privacy-policy#collection-information'>1. Collection of Information.</Link></li>
                    <li><Link className={'link'} to='/legal/privacy-policy#use-information'>2. Use of information.</Link></li>
                    <li><Link className={'link'} to='/legal/privacy-policy#sharing-information'>3. Sharing of information.</Link></li>
                    <li><Link className={'link'} to='/legal/privacy-policy#security-information'>4. Security of information.</Link></li>
                    <li><Link className={'link'} to='/legal/privacy-policy#questions-or-complaints'>5. Questions or Complaints.</Link></li>
                </ul>
            </p>
            <br/>
            <div id={'collection-information'}>
                <p>
                    <b>COLLECTION OF INFORMATION</b>
                </p>
                <br/>
                <p>
                    In connection with access to our Services, we may collect personal information,
                    such as your name, shipping / billing address, email address, phone, credit
                    card/bank account number, username and password.
                </p>
                <br/>
                <p>We may automatically collect certain usage information when you access our
                    Services ("Usage Data"), such as Internet Protocol (“IP”) addresses, log files,
                    unique device identifiers, pages viewed, browser type, any links you click on to
                    leave or interact with our Services, and other usage information collected from
                    cookies and other tracking technologies. For example, we may collect IP
                    addresses to track and aggregate retained in pseudonym form (replacing any
                    directly identifying characteristics of personal information, to monitor the
                    locations from which users navigate to our Services. We may also collect IP
                    addresses from users when they log into the Services as part of our log-in and
                    security features. We may also, when you enable location-based Services, collect
                    Global Positioning System (GPS) location data and/or motion data.
                </p>    
            </div>
            <br/>
            <div id={'use-information'}>
                <p>
                    <b>USE OF INFORMATION</b>
                </p>
                <br/>
                <p>We may use your information for the following purpose:</p>
                <ul>
                    <li>1. Account Registration</li>
                    <p>We may use your name, address, phone number, billing information and email
                        address to register your account for certain services we provide and communicate
                        important information to you.
                    </p>
                    <li>2.Customer Services and Technical Support.</li>
                    <p>We may use your name, address, phone number, email address, how you interact
                        with our Services and information about your computer configuration to resolve
                        questions you may have about our Services and to follow up with you about your
                        experience.
                    </p>
                    <li>3. Feedback</li>
                    <p>We may take some surveys to improve our features and the overall of our
                        services. Answering any survey is optional.
                    </p>
                </ul>
            </div>
            <br/>
            <div id={'sharing-information'}>
                <p>
                    <b>SHARING OF INFORMATION</b>
                </p>
                <br/>
                <p>
                    <ul>
                        <li>1.Syncing, Linking, Connecting Other Third Party Services with our services.
                        </li>
                        <p>We may share your information, including personal information and usage data,
                            with third party service providers who perform various functions to enable us to
                            provide our services and help us to improve our site.</p>
                        <li>2.United States Postal Service (USPS)
                        </li>
                        <p>
                            Shipsland is regulated by the USPS. Shipsland collects some information about
                            you on behalf of the USPS. The USPS may also send tracking data from their scans
                            of your mail and package the mailstreams.

                        </p>
                    </ul>
                </p>
            </div>
            <br/>
            <div id={'security-information'}>
                <p>
                    <b>SECURITY OF INFORMATION</b>
                </p>
                <br/>
                <p>
                    We do not sell, hire, lease or rent the personal information we collect to
                    anyone. Unless we have your permission, are required by law, are required to do
                    so in order to enforce or apply our terms of use and other agreements with you
                    or are required to do so to protect the rights, property or safety of Shipsland,
                    our customers or others, we will only provide personal information to other
                    Shipsland entities within our group.
                </p>
            </div>
            <br/>
            <div id={'questions-or-complaints'}>
                <p>
                    <b>QUESTIONS</b>
                </p>
                <br/>
                <p>You can contact <a href="mailto:support@shipsland.com"> support@shipsland.com</a>, if you have any questions or comments about  services and privacy statements</p>
                </div>
          </div>
          </React.Fragment>
    );
}
export default PrivacyPolicy;